import moment from 'moment';

/**
 * Build MetQL® query string
 *
 * Example: TODO: put up-to-date example here
 *
 * @returns {string} MetQL query
 *
 * TODO: maybe generalize
 * TODO: make pure for unit testing
 */
const generateMetQL = (options, store, allDataSeries) => {

    options = {
        forListApi: 'forListApi' in options ? options.forListApi : false,
        format: 'format' in options ? options.format : 'json',
        prettyPrint: 'prettyPrint' in options ? options.prettyPrint : false,
        checkOnly: 'checkOnly' in options ? options.checkOnly : false,
        asUrlQuery: 'asUrlQuery' in options ? options.asUrlQuery : false,
        runOnJobQueue: 'runOnJobQueue' in options ? options.runOnJobQueue : false,
        jobQueueRedirect: 'jobQueueRedirect' in options ? options.jobQueueRedirect : false
    }

    let metQL = {};

    // units of measurement, e. g. "units":{"temperature":"°F","velocity":"kn","length":"imperial"}}
    metQL.units = {
        temperature: store.temperatureUnit,
        velocity: store.windspeedUnit,
        length: store.lengthUnit,
        energy: store.energyUnit
    }

    // check only?
    if(options.checkOnly) {
        metQL.checkOnly = true
    }

    // job queue
    if(options.runOnJobQueue) {
        metQL.runOnJobQueue = true
    }

    // job queue redirect to avoid firefox fetch issues
    if(options.runOnJobQueue) {
        metQL.jobQueueRedirect = options.jobQueueRedirect
    }

    // is combined locations + time?
    if(store.locationSelectionMode === 'coordinatesDatesList') {
        metQL.oneTimeIntervalPerGeometry = true
    }

    // Location(s)

    metQL.geometry = {
        "type": "MultiPoint",
        "coordinates": [],
        "locationNames": []
    }

    if(store.locationSelectionMode === 'locationSearch') {
        if(store.locations !== undefined && store.locations.length > 0) {
            metQL.geometry.coordinates = store.locations
                .map(location => location.key.split('%')[0]
                    .split('/').map(coord => parseFloat(coord)));
            metQL.geometry.locationNames = store.locations
                .map(location => location.key.split('%')[1]);
        }

    } else if((store.locationSelectionMode === 'coordinatesList'
        && typeof store.coordsList !== 'undefined')
        || (store.locationSelectionMode === 'coordinatesDatesList'
        && typeof store.coordsDatesList !== 'undefined'))
    {
        var source = store.locationSelectionMode === 'coordinatesList'
            ? store.coordsListParsed
            : store.coordsDatesListParsed
        metQL.geometry.locationNames = []
        metQL.geometry.coordinates = source.map(line => {
                let ret = [line[1],line[0]]
                if(line[2]) ret.push(line[2])
                metQL.geometry.locationNames.push(line[3] ? line[3] : '')
                return ret
            })

    } else if(store.locationSelectionMode === 'customArea' && store.customPolygon !== undefined) {
        metQL.geometry = JSON.parse(JSON.stringify(store.customPolygon.geometry))

    } else if(store.locationSelectionMode === 'area') {
        metQL.geometry = {
            "type": "GeonamePolygon",
        }

        if (store.geonameIds.length === 1) {
            metQL.geometry = {
                "type": "GeonamePolygon",
                "geonameid": parseInt(store.geonameIds[0])
            }
        } else {
            metQL.geometry = {
                "type": "MultiGeonamePolygon",
                "geonameids": store.geonameIds.map(id => parseInt(id))
            }
        }

    } else if(store.locationSelectionMode === 'geoJson'
        && typeof store.geoJsonParsed !== 'undefined'
        && 'geometry' in store.geoJsonParsed)
    {
        metQL.geometry = store.geoJsonParsed.geometry
    } else {
        delete metQL.geometry
    }

    /* transform MultiPoint geometry to GeometryCollection of MultiPoints
       when 'Coordinates and time' input is used. */
    if(store.locationSelectionMode === 'coordinatesDatesList' === true
        && 'geometry' in metQL) {

        metQL.oneTimeIntervalPerGeometry = true

        let geometry = {
            "type": "GeometryCollection",
            "geometries": []
        }
    
        geometry.geometries = metQL.geometry.coordinates.map((coords, i) => {
            return {
                "type": "MultiPoint",
                "coordinates": [coords],
                "locationNames": [metQL.geometry.locationNames[i]]
            }
        })

        metQL.geometry = geometry
    }

    // exclude sea points
    if(store.excludeSeaPoints && 'geometry' in metQL) {
        metQL.geometry.excludeSeaPoints = true
    }

    // include neighbour grid-cells
    if(store.includeNeighbours && 'geometry' in metQL) {
        metQL.geometry.includeNeighbours = true
    }

    // the returned format
    metQL.format = options.format;

    // Time intervals
    if(store.timeSelectionMode === 'timeIntervals'
        && store.dateRanges.length > 0
        && store.locationSelectionMode !== 'coordinatesDatesList') {

        metQL.timeIntervals = store.dateRanges
            .filter(dateRange => dateRange.length === 2)
            .map(dateRange => 
                `${dateRange[0]}T${store.utcOffset}/${dateRange[1]}T${store.utcOffset}`
            )
    }

    // Time Intervals CSV
    if(store.timeSelectionMode === 'timeIntervalsCsv'
        && store.locationSelectionMode !== 'coordinatesDatesList') {
        metQL.timeIntervals = store.timeIntervalsListParsed.map(dates =>
            `${dates[0]}T${store.utcOffset}/` +
            `${dates[1]}T${store.utcOffset}`
        )
    }

    // Startdate + years
    if(store.timeSelectionMode === 'startdateYears'
        && store.locationSelectionMode !== 'coordinatesDatesList') {
        metQL.timeIntervals = store.startDateYearsValues.map((year, i) => {
                let month = store.startDateMonth
                let day = store.startDateDay
                let numDays = parseInt(store.startDateNumDays)
                let startDate = `${year.toString().padStart(4,'0')}-` + 
                    `${month.padStart(2,'0')}-${day.padStart(2,'0')}`
                let endDate = moment(startDate).add(numDays - 1,'days')
                let endDateString = endDate.isValid() ? endDate.format('YYYY-MM-DD') : '2038-01-19'
                let utcOffset = store.utcOffset
                return `${startDate}T${utcOffset}/${endDateString}T${utcOffset}`
            })
    }

    // Locations + time intervals CSV
    if(store.locationSelectionMode === 'coordinatesDatesList') {
        metQL.timeIntervals = store.coordsDatesListParsed.map(val =>
            `${val[4]}${val[4].indexOf('T') === -1 ? 'T' : ''}${store.utcOffset}/` +
            `${val[5]}${val[5].indexOf('T') === -1 ? 'T' : ''}${store.utcOffset}`
        )
    }

    // If we need only the location and time for the list api we can return here
    if(options.forListApi) {
        return JSON.stringify(metQL)
    }

    // Data Series

    let generateSeriesQuery = (dataSeries, depth = 0) => {

        depth++

        let queries = [];

        if(dataSeries === undefined) {
            return
        }

        dataSeries.forEach((d, key) => {

            if('dataSeries' in d && d.dataSeries !== undefined) {

                let query = {
                    domain: d.dataSeries[1],
                    gapFillDomain: store.fillGapsWith === 'none' ? null : store.fillGapsWith,
                    timeResolution: d.dataSeries[4],
                    codes: [{
                        code: d.dataSeries[2],
                        level: d.dataSeries[3]
                    }]
                }

                if (typeof d.dataSeries[5] !== 'undefined') {
                    query.codes[0].aggregation = d.dataSeries[5]
                }

                if ('transformations' in d) {

                    // restructure transformation objects
                    let transformations = d.transformations
                        .filter(transf => 
                            // filter empty fields to prevent api errors
                            /* TODO: for now this only handles empty data series fields. find better
                                solution, e.g. prevent user from adding data series fields, while 
                                there are empty transformation inputs */
                            !(Object.keys(transf)[0] === 'dataSeries'
                            && transf.dataSeries === undefined)
                        )
                        .map(transf => {
                            if ('dataSeries' in transf) {
                                return {
                                    type: transf.type,
                                    ...transf[transf.type],
                                    dataQuery: generateSeriesQuery([transf], depth)[0]
                                }
                            } else {
                                return transf
                            }
                    })

                    query.transformations = []
                    query.transformations.push(...transformations)
                }

                // add data query params
                if ('dataSeriesParams' in d) {
                    query.codes[0] = Object.assign(query.codes[0], d.dataSeriesParams)
                }

                queries.push(query);

            } else {
                // TODO: find better solution
                // alert('Error: Please remove empty data series input fields and select again.')
            }

        })

        return queries
    }

    metQL.timeIntervalsAlignment = store.timeIntervalsAlignment

    metQL.queries = generateSeriesQuery(allDataSeries)

    if(options.prettyPrint) {
        return JSON.stringify(metQL, null, 4) + '\n'
    } else if(options.asUrlQuery) {
        return encodeURIComponent(JSON.stringify(metQL))
    } else {
        return JSON.stringify(metQL)
    }
}

export default generateMetQL